<template>
    <products-carousel-section
        class="bonus-recipe-carousel-section-module"
        :title="attributes.bonusRecipe_title"
        :slides="formattedSlides"
        :button-text="attributes.bonusRecipe_button_text"
        :button-link="buttonLink"
        :show-navigation-buttons="attributes.bonusRecipe_show_navigation_buttons"
    />
</template>

<script>
    import ProductsCarouselSection from '../../../organisms/ProductsCarouselSection/ProductsCarouselSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'bonus-recipe-carousel-section-module',

        components: { ProductsCarouselSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Safely return the button link.
             *
             * @returns {string}
             */
            buttonLink() {
                return this.attributes.bonusRecipe_button_link
                    ?.uri;
            },

            /**
             * Format api data for the carousel.
             *
             * @returns {Array}
             */
            formattedSlides() {
                return (this.attributes.recipes || []).map((recipe) => ({
                    name: recipe.name,
                    image: formatMediaObject.call(this, recipe.desktop_image),
                    to: recipe.page.uri,
                }));
            },
        },
    };
</script>
